import { createStoreCreator } from 'lib/store'
import reducer from 'reports/stoppagesPareto/reducers'

export default createStoreCreator(reducer)
